var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer bg-dark text-white py-4"},[_c('div',{staticClass:"footer-bottom text-center mt-3"},[_c('p',{staticClass:"mb-0"},[_vm._v(" © 2024 Marcell Andreas Samadhani Duha - Codepolitan ")])])])
}]

export { render, staticRenderFns }